var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"techTreeView"},[(!_vm.object.data)?_c('h3',[_vm._v("Loading...")]):_c('div',{staticClass:"tree"},[_c('TechTreeNode',{attrs:{"object":_vm.object,"nodes":_vm.object.data.techTree,"selectedObject":_vm.selectedObject},on:{"expand":_vm.expand}})],1),_vm._v(" "),(_vm.selectedObject)?_c('div',{staticClass:"subtree"},[_c('TechTreeView',{attrs:{"object":_vm.selectedObject}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8aada41a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TechTreeView.vue
// module id = 127
// module chunks = 0